import React, {Fragment, useState} from 'react';
import _ from "lodash";
import classNames from "classnames";

const withPagingHoc = (ChildComponent) => {

    const PagingActions = (props) => {

        const [pageNumber, setPageNumber] = useState(1);
        const [totalPages , setTotalPages] = useState(0) ;
        const updatePage = (page) => {
            if (pageNumber !== page && page !== 0 && page !== totalPages+1 ){
                // if (!ordersPaging[page]) {
                setPageNumber(page) ;
                // }
            }
        };

        const paginationRender = (currentPage , totalPages) => {
            const showingPages = showingPageNumbers(currentPage ,totalPages) ;

            return (
                <div className="pagination organizer">
                    <div className={classNames("paginationItem" , {"clickShape" : currentPage > 1})} onClick={() => updatePage(pageNumber-1)}>
                        <span className="icon icon-arrow-right font-size_14"></span>
                    </div>
                    {
                        _.map(showingPages , (page , index) => {
                            return (
                                <Fragment>
                                    <div className={classNames("paginationItem" , {"active" : page === pageNumber , "clickShape" : page !== pageNumber})} key={page} onClick={() =>updatePage(page)}>
                                        <span className="pageNumberBox">{page}</span>
                                    </div>
                                    {page !== totalPages && showingPages[index+1] > page + 1 ?
                                        <div className="paginationItem">
                                            <span className="icon icon-more"></span>
                                        </div> : null}
                                </Fragment>
                            );
                        })
                    }
                    <div className={classNames("paginationItem" , {"clickShape" : currentPage < totalPages })} onClick={() => updatePage(pageNumber+1)}>
                        <span className="icon icon-arrow-left font-size_14"></span>
                    </div>
                </div>
            );
        };

        const showingPageNumbers = (currentPage , totalPages) => {
            let showingPages = [1] ;
            setTotalPages(totalPages) ;
            if (currentPage-1 > 0 && _.indexOf(showingPages , currentPage-1) === -1) {
                showingPages.push(currentPage-1) ;
            }
            if (_.indexOf(showingPages , currentPage) === -1) {
                showingPages.push(currentPage) ;
            }
            if (currentPage+1 <= totalPages && _.indexOf(showingPages , currentPage+1) === -1) {
                showingPages.push(currentPage+1) ;
            }
            if (_.indexOf(showingPages , totalPages) === -1) {
                showingPages.push(totalPages) ;
            }

            return showingPages ;
        };

        const newProps = {...props, pageNumber, setPageNumber, updatePage, showingPageNumbers, paginationRender};

        return <ChildComponent {...newProps}  />
    };

    return PagingActions;
};

export default withPagingHoc;